import React from 'react'

const ErrorLabel = props => {
  const { before, htmlFor, error: errorArg, after, createErrorLabelStyles, ...rest } = props
  if (!errorArg) {
    return null
  }
  const error = errorArg.toArray ? errorArg.toArray() : errorArg
  let style = {}

  if (createErrorLabelStyles) {
    style = createErrorLabelStyles(error)
  }

  return (
    <label className="label error" htmlFor={htmlFor} {...rest} style={{ marginTop: '8px', ...style }}>
      {Array.isArray(error) ? (
        error.map(singleError =>
          singleError instanceof Error ? (
            <span key={singleError.message}>
              {before} {singleError.message} {after}
            </span>
          ) : (
            <span key={singleError}>
              {before} {singleError} {after}
            </span>
          )
        )
      ) : error instanceof Error ? (
        <span>
          {before} {error.message} {after}
        </span>
      ) : (
        <span>
          {before} {error} {after}
        </span>
      )}
    </label>
  )
}

ErrorLabel.displayName = 'ErrorLabel'

export default ErrorLabel
